// load appsignal first before anything else
import { appsignal } from './appsignal'
import { appcues } from './appcues'

// We import the CSS which is extracted to its own file by esbuild.
// Remove this line if you add a your own CSS build pipeline (e.g postcss).
import '../css/app.scss'

// If you want to use Phoenix channels, run `mix help phx.gen.channel`
// to get started and then uncomment the line below.
// import "./user_socket.js"

// You can include dependencies in two ways.
//
// The simplest option is to put them in assets/vendor and
// import them using relative paths:
//
//     import "../vendor/some-package.js"
//
// Alternatively, you can `npm install some-package --prefix assets` and import
// them using a path starting with the package name:
//
//     import "some-package"
//

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import 'phoenix_html'
// Establish Phoenix Socket and LiveView configuration.
import { Socket } from 'phoenix'
import { LiveSocket } from 'phoenix_live_view'
import topbar from 'topbar'

import chartHooks from './hooks/charts'
import formHooks from './hooks/forms'
import layoutHooks from './hooks/layout'
import materialDesignHooks from './hooks/material_design'
import mapboxHooks from './hooks/mapping'
import utilityHooks from './hooks/utility'
import draggableHooks from './hooks/draggable'

// https://hexdocs.pm/phoenix_live_view/js-interop.html#client-hooks
let hooks = {
  ...chartHooks,
  ...formHooks,
  ...layoutHooks,
  ...materialDesignHooks,
  ...mapboxHooks,
  ...utilityHooks,
  ...draggableHooks
}

let csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute('content')

let liveSocket = new LiveSocket('/live', Socket, {
  // NTW: disabled as it seems to be to aggressive and causes issues with some of our data intense pages like New PA for large landscapes
  // longPollFallbackMs: 2500,
  params: { _csrf_token: csrfToken },
  timeout: 120000,
  hooks
})

// Show progress bar on live navigation and form submits
topbar.config({
  barColors: { 0: '#29d' },
  shadowColor: 'rgba(0, 0, 0, .3)',
  className: 'topbar'
})
if (!window.location.pathname.startsWith('/hl/')) {
  window.addEventListener('phx:page-loading-start', (_info) => {
    topbar.show()
  })
}
window.addEventListener('phx:page-loading-stop', (_info) => {
  topbar.hide()
})

// see https://hexdocs.pm/phoenix_live_view/Phoenix.LiveView.JS.html#module-custom-js-events-with-js-dispatch-1-and-window-addeventlistener
// for implementation background
// handy when you need to return user to top of page after an action
window.addEventListener('vp:scroll-to-top', (_info) => {
  window.scrollTo(0, 0)
})

// connect if there are any LiveViews on the page
liveSocket.connect()

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket
